/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateFileEventSchema = z.enum(['scanned'])

export type CandidateFileEventSchema = z.infer<typeof candidateFileEventSchema>
